/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Page_DescriptionInputs */

const en_keyword_optimizer_page_description = /** @type {(inputs: Keyword_Optimizer_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check how well your resume matches a job description's keywords — then get AI-powered rewording suggestions.`)
};

const de_keyword_optimizer_page_description = /** @type {(inputs: Keyword_Optimizer_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfe, wie gut dein Lebenslauf zu den Keywords einer Stellenbeschreibung passt — und erhalte KI-gestützte Umformulierungsvorschläge.`)
};

const fr_keyword_optimizer_page_description = /** @type {(inputs: Keyword_Optimizer_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifiez la correspondance des mots-clés de votre CV avec l'offre d'emploi — puis obtenez des suggestions de reformulation par IA.`)
};

const es_keyword_optimizer_page_description = /** @type {(inputs: Keyword_Optimizer_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprueba cómo encajan las palabras clave de tu CV con la oferta de empleo y obtén sugerencias de reformulación con IA.`)
};

const it_keyword_optimizer_page_description = /** @type {(inputs: Keyword_Optimizer_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica quanto le parole chiave del tuo CV corrispondono all'annuncio di lavoro — e ottieni suggerimenti di riformulazione con l'IA.`)
};

const nl_keyword_optimizer_page_description = /** @type {(inputs: Keyword_Optimizer_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controleer hoe goed de zoekwoorden in je CV overeenkomen met de vacature — en ontvang AI-gestuurde herformuleringssuggesties.`)
};

const pl_keyword_optimizer_page_description = /** @type {(inputs: Keyword_Optimizer_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdź, jak dobrze słowa kluczowe w Twoim CV pasują do ogłoszenia o pracę — i uzyskaj sugestie przeformułowania od AI.`)
};

const fi_keyword_optimizer_page_description = /** @type {(inputs: Keyword_Optimizer_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarkista, miten hyvin ansioluettelosi avainsanat vastaavat työpaikkailmoitusta — ja saat tekoälyn uudelleenmuotoiluehdotuksia.`)
};

const da_keyword_optimizer_page_description = /** @type {(inputs: Keyword_Optimizer_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tjek hvor godt dit CV matcher en jobopslagets nøgleord — og få AI-drevne omformuleringsforslag.`)
};

const sv_keyword_optimizer_page_description = /** @type {(inputs: Keyword_Optimizer_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrollera hur väl nyckelorden i ditt CV matchar jobbannonsen — och få AI-drivna omformuleringsförslag.`)
};

/**
* | output |
* | --- |
* | "Check how well your resume matches a job description's keywords — then get AI-powered rewording suggestions." |
*
* @param {Keyword_Optimizer_Page_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_page_description = /** @type {((inputs?: Keyword_Optimizer_Page_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Page_DescriptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_page_description(inputs)
	if (locale === "fr") return fr_keyword_optimizer_page_description(inputs)
	if (locale === "es") return es_keyword_optimizer_page_description(inputs)
	if (locale === "it") return it_keyword_optimizer_page_description(inputs)
	if (locale === "nl") return nl_keyword_optimizer_page_description(inputs)
	if (locale === "pl") return pl_keyword_optimizer_page_description(inputs)
	if (locale === "fi") return fi_keyword_optimizer_page_description(inputs)
	if (locale === "da") return da_keyword_optimizer_page_description(inputs)
	if (locale === "sv") return sv_keyword_optimizer_page_description(inputs)
	return en_keyword_optimizer_page_description(inputs)
});